import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file",
  "use": "icon-file-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"icon-file\">\n    \n    <g>\n    <path d=\"M25.182 0.609h-24.572v30.714h30.714v-24.571l-6.142-6.142zM21.494 2.658v5.118h-2.252v-5.12h2.252zM17.194 2.658v5.118h-8.394v-5.12h8.394zM8.8 29.275v-12.694h14.334v12.695h-14.334zM29.276 29.275h-4.095v-14.745h-18.431v14.745h-4.092v-26.617h4.094v7.163h16.79v-7.163h0.82l4.914 4.913v21.705z\" fill=\"rgba(16.065,16.065,16.065,1)\" />\n    </g>\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol